import { makeBinded } from '../../lib/makeBinded';
import { httpService } from '../../services/http.service';
import type { CreateRepositoryMethodOptions } from 'utils';
import type { UsersDto } from './users.dto';

const mfaGuardErrorCode = {
  TOKEN_EXPIRED: 'mfaGuardErrorCode/TOKEN_EXPIRED',
} as const;

export namespace UsersRepositoryNamespace {
  export type LoginWithEmailPasswordOptions = CreateRepositoryMethodOptions<{
    body: UsersDto.Auth.LoginWithEmailPassword.Body;
  }>;

  export type SendLoginOtpOptions = CreateRepositoryMethodOptions<{
    jwt: string;
  }>;

  export type VerifyLoginOtpOptions = CreateRepositoryMethodOptions<{
    body: { otp: string };
    jwt: string;
  }>;
}

class UsersRepository {
  private readonly _httpService = httpService;
  private readonly _baseUrl = `${env.VITE_AMMINISTRO_API_GATEWAY}/api/v2/users`;

  async loginWithEmailPassword({ body }: UsersRepositoryNamespace.LoginWithEmailPasswordOptions) {
    return this._httpService.post<{ data: UsersDto.Auth.LoginWithEmailPassword.Response }>(
      `${this._baseUrl}/auth/email-password`,
      { data: body },
    );
  }

  async sendLoginOtp({ jwt }: UsersRepositoryNamespace.SendLoginOtpOptions) {
    return this._httpService.post<never>(
      `${this._baseUrl}/send-otp`,
      { },
      { headers: { Authorization: `Bearer ${jwt}` } },
    );
  }

  async verifyLoginOtp({ body, jwt }: UsersRepositoryNamespace.VerifyLoginOtpOptions) {
    return this._httpService.post<{ data: { jwt: string } }>(
      `${this._baseUrl}/verify-otp`,
      { data: body },
      { headers: { Authorization: `Bearer ${jwt}` } },
    );
  }
}

const usersRepository = makeBinded(UsersRepository)();

export { usersRepository, mfaGuardErrorCode, UsersRepository };
